module.exports = __webpack_public_path__ + "static/soehne-web-halbfett-5e8377fa8ea80f4496ff717425b03e1a.woff";